import React from "react";

import { useSelector } from "react-redux";

import {
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import { useCart } from "../../components/CartContext";

import "./css/Header.css";


function Header() {

  const {
    restaurantId,
    tableId,
  } = useParams();

  const navigate = useNavigate();

  const location = useLocation();

  const {
    cartCount,
  } = useCart();

  const {
    restaurantName,
  } = useSelector(
    (state) => state.menu
  );


  /* =========================================
     HOME PATH
  ========================================= */

  const homePath =
    `/${restaurantId}/table/${tableId}`;


  /* =========================================
     GO HOME
  ========================================= */

  const goHome = () => {

    navigate(homePath);

  };


  /* =========================================
     GO CART
  ========================================= */

  const goCart = () => {

    navigate(
      `${homePath}/cart`
    );

  };


  /* =========================================
     NAVIGATE TO HOME SECTION
  ========================================= */

  const navigateToSection = (sectionId) => {

    /*
      If already on HomeScreen,
      scroll directly.
    */

    const isHomePage =
      location.pathname === homePath;


    if (isHomePage) {

      const section =
        document.getElementById(
          sectionId
        );


      if (section) {

        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

      return;
    }


    /*
      If we are on Cart / Checkout /
      Payment / Order etc., go to
      HomeScreen first and attach
      the section as a hash.
    */

    navigate(
      `${homePath}#${sectionId}`
    );

  };


  return (

    <header className="theme2-header">

      <div className="theme2-header-inner">


        {/* =====================================
            RESTAURANT LOGO
        ====================================== */}

        <button
          type="button"
          className="theme2-header-logo"
          onClick={goHome}
        >

          <span className="theme2-header-logo-small">

            KITCHEN & SOCIAL

          </span>


          <span className="theme2-header-logo-name">

            {restaurantName ||
              "OUR RESTAURANT"}

          </span>

        </button>


        {/* =====================================
            NAVIGATION
        ====================================== */}

        <nav className="theme2-header-navigation">


          {/* MENU */}

          <button
            type="button"
            onClick={() =>
              navigateToSection("menu")
            }
          >

            MENU

          </button>


          {/* ABOUT */}

          <button
            type="button"
            onClick={() =>
              navigateToSection("about")
            }
          >

            ABOUT

          </button>


          {/* CONTACT */}

          <button
            type="button"
            onClick={() =>
              navigateToSection("contact")
            }
          >

            CONTACT

          </button>

        </nav>


        {/* =====================================
            CART
        ====================================== */}

        <button
          type="button"
          className="theme2-header-cart"
          onClick={goCart}
          aria-label="Open cart"
        >

          <span className="theme2-cart-icon">

            🛒

          </span>


          <span className="theme2-cart-text">

            CART

          </span>


          <span className="theme2-cart-count">

            {cartCount}

          </span>

        </button>

      </div>

    </header>

  );
}


export default Header;